import { NgModule } from '@angular/core';
import { SignUpContainerComponent, SignUpFormDirective, SignUpStepDirective, SignUpSubtextDirective } from './sign-up-container.component';
import { SharedModule } from '../../../shared/shared.module';
import { ButtonModule } from '../../../shared/button/button.module';
import { PrivacyPolicyDialogModule } from '../../../shared/privacy-policy-dialog/privacy-policy-dialog.module';
import { TermsOfServiceDialogModule } from '../../../shared/terms-of-service-dialog/terms-of-service-dialog.module';
import { AuthLogoModule } from '../../shared/auth-logo/auth-logo.module';

@NgModule({
    imports: [
        SharedModule,
        ButtonModule,
        PrivacyPolicyDialogModule,
        TermsOfServiceDialogModule,
        AuthLogoModule,
    ],
    declarations: [
        SignUpContainerComponent,
        SignUpFormDirective,
        SignUpStepDirective,
        SignUpSubtextDirective,
    ],
    exports: [
        SignUpContainerComponent,
        SignUpFormDirective,
        SignUpStepDirective,
        SignUpSubtextDirective,
    ],
})
export class SignUpContainerModule
{
}
